export const DEFAULT_SUGGESTION_COUNT = 10;
export const FILTER_COLLAPSED_SUMMARY_MAX_DISPLAY_COUNT = 3;
